import {
    inject,
    Component,
    Input,
    OnInit,
    Renderer2
} from '@angular/core';

import { GeneralInputButton } from '@tilby/tilby-ui-lib/models';

import {
    TilbyGeneralInputButtonComponent,
    TilbyGeneralInputButtonPanelComponent
} from '@tilby/tilby-ui-lib/components/tilby-buttons';

import { ToolbarEventsContextService } from 'src/app/core/services/toolbar-events/toolbar-events-context.service';
import { ToolbarEventsService } from "src/app/core/services/toolbar-events/toolbar-events.service";
import { MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";
import { AsyncPipe } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { subscribeInComponent } from "src/app/shared/angular-utils";

@Component({
    selector: 'app-buttons-bar',
    templateUrl: './buttons-bar.component.html',
    styleUrls: ['./buttons-bar.component.scss'],
    standalone: true,
    imports: [
        TilbyGeneralInputButtonComponent,
        TilbyGeneralInputButtonPanelComponent,
        MatMenuModule,
        MatButtonModule,
        AsyncPipe,
        MatIconModule,
        MatInputModule
    ],
    providers: []
})
export class ButtonsBarComponent implements OnInit {
    public toolbarEventsService = inject(ToolbarEventsService);
    public toolbarEventsContextService = inject(ToolbarEventsContextService);
    private renderer = inject(Renderer2);

    @Input() isContextToolbar = false;
    myButtonService?: ToolbarEventsContextService | ToolbarEventsService;

    constructor() {
        subscribeInComponent(this.toolbarEventsService.events, (event) => {
            if (event.type === 'toolbar.button_css') {
                const button = document.querySelectorAll(`[name="${event.button}"]`)[0];

                if (!button) {
                    return;
                }

                switch (event.action) {
                    case 'addCssClass':
                        this.renderer.addClass(button, event.cssClass || '');
                        break;
                    case 'removeCssClass':
                        this.renderer.removeClass(button, event.cssClass || '');
                        break;
                }
            }
        });
    }

    ngOnInit(): void {
        this.myButtonService = this.isContextToolbar ? this.toolbarEventsContextService : this.toolbarEventsService;
    }

    checkPanelButtons(btns: GeneralInputButton[] | undefined) {
        return btns?.some((btn) => btn.isIt() === true);
    }
}
